/* eslint-disable */
import React from "react";

// @material-ui/core components
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";
import GitHubIcon from '@material-ui/icons/GitHub';
import ForumIcon from '@material-ui/icons/Forum';

// core components
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-kit-pro-react/components/headerLinksStyle.js";

import {connect} from "react-redux";
import store from "../../redux/Store";
import storage from "../../utils/storage";
import {withStyles} from "@material-ui/core/styles";

import {withRouter} from 'react-router-dom'
import intl from "react-intl-universal";
import CustomDropdown from "../../components/CustomDropdown/CustomDropdown";

import GTranslateIcon from '@material-ui/icons/GTranslate';
import cookie from 'react-cookies'
import Primary from "../../components/Typography/Primary";

const useStyles = styles;

class BaseHeaderLinks extends React.Component {

	constructor(props) {
		super(props);

	};

	logout = () => {
		storage.remove("token");
		store.dispatch({
			type: "logout"
		});
		store.dispatch({
			type: "display"
		});
		store.dispatch({
			type: "mine_display"
		});
		this.props.history.push('/login')
	};

	changeLangEnglish = () => {
		if (cookie.load("lang") !== 'en-US') {
			let inFifteenMinutes = new Date(new Date().getTime() + 24 * 3600 * 1000 * 365);//一天
			cookie.save('lang', 'en-US', {expires: inFifteenMinutes, path: '/'});
			window.location.reload(true);
		}

	};
	changeLangChinese = () => {
		if (cookie.load("lang") !== 'zh-CN') {
			let inFifteenMinutes = new Date(new Date().getTime() + 24 * 3600 * 1000 * 365);//一天
			cookie.save('lang', 'zh-CN', {expires: inFifteenMinutes, path: '/'});
			window.location.reload(true);
		}
	};

	render() {


		const {classes} = this.props
		return (
			<List className={classes.list + " " + classes.mlAuto}>
				<ListItem className={classes.listItem}>
					<Button
						href="/series"
						color="transparent"
						className={classes.navLink}
					>
						{intl.get('series')}
					</Button>
				</ListItem>
				<ListItem className={classes.listItem}>
					<Button
						href="/video"
						color="transparent"
						className={classes.navLink}
					>
						{intl.get('video')}
					</Button>
				</ListItem>

				<ListItem className={classes.listItem}>
					<Button
						href="/plans"
						color="transparent"
						className={classes.navLink}
					>
						{intl.get('subscription')}
					</Button>
				</ListItem>

				<ListItem className={classes.listItem}>
					<Button
						href="/about"
						color="transparent"
						className={classes.navLink}
					>
						{intl.get('about')}
					</Button>
				</ListItem>
				{
					this.props.userLoginStatus ?
						<span>
							<ListItem className={classes.listItem}>
							<Button
								href="/account"
								color="transparent"
								className={classes.navLink}
							>
								{intl.get('account')}
							</Button>
							</ListItem>
							<ListItem className={classes.listItem}>
							<Button
								color="transparent"
								className={classes.navLink}
								onClick={this.logout}
							>
								{intl.get('logout')}
							</Button>
							</ListItem>
						</span>
						:
						<span>
							<ListItem className={classes.listItem}>
							<Button
								href="/login"
								color="transparent"
								className={classes.navLink}
							>
								{intl.get('login')}
							</Button>
							</ListItem>
							<ListItem className={classes.listItem}>
							<Button
								href="/signUp"
								color="transparent"
								className={classes.navLink}
							>
								{intl.get('registered')}
							</Button>
							</ListItem>
						</span>

				}
				<ListItem className={classes.listItem}>
					<CustomDropdown
						buttonText={
							<div>
								<GTranslateIcon/>{intl.get('lang')}
							</div>
						}
						buttonProps={{
							className: classes.navLink,
							color: "transparent"
						}}
						dropdownList={[
							<div
								color="transparent"
								// className={classes.navLink}
								onClick={this.changeLangChinese}
							>
								中文
							</div>
							,
							<div
								color="transparent"
								// className={classes.navLink}
								onClick={this.changeLangEnglish}
							>
								English
							</div>
						]}
					/>
				</ListItem>
				<ListItem className={classes.listItem}>
					<Tooltip
						id="into-github"
						title={intl.get('menu_git')}
						placement={window.innerWidth > 959 ? "top" : "left"}
						classes={{tooltip: classes.tooltip}}
					>
						<Button
							href="https://github.com/clwater/LeetCodeAllAnimation"
							target="_blank"
							color="transparent"
							className={classes.navLink}
						>
							<GitHubIcon/>
						</Button>
					</Tooltip>
				</ListItem>
				<ListItem className={classes.listItem}>
					<Tooltip
						id="into-fornum"
						title={intl.get('menu_forum')}
						placement={window.innerWidth > 959 ? "top" : "left"}
						classes={{tooltip: classes.tooltip}}
					>
						<Button
							color="transparent"
							href="https://forum.robinalgo.com/"
							target="_blank"
							className={classes.navLink}
						>
							<ForumIcon/>
						</Button>
					</Tooltip>
				</ListItem>
			</List>
		);
	}

}

const mapStateToProps = state => ({
	userLoginStatus: state.userLoginStatus
});


export default connect(mapStateToProps)((withStyles(useStyles)(withRouter(BaseHeaderLinks))));

